import { ChangeDetectionStrategy, Component, effect, input } from '@angular/core';
import { MdbSelectModule } from 'mdb-angular-ui-kit/select';
import { KeyValuePipe } from '@angular/common';
import {
  AbstractControl,
  FormGroup,
  ReactiveFormsModule,
} from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { MdbValidationModule } from 'mdb-angular-ui-kit/validation';

@Component({
  selector: 'app-enum-select',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    MdbSelectModule,
    ReactiveFormsModule,
    KeyValuePipe,
    TranslateModule,
    MdbValidationModule,
  ],
  templateUrl: './enum-select.component.html',
  standalone: true,
  styles: '',
})
export class EnumSelectComponent {
  formGroup = input.required<FormGroup>();
  clearButton = input(false);
  controlName = input.required<string>();
  enum = input.required<any>();
  label = input('');
  isRequired = input(false);
  castFunction = input<(arg: any) => string>()
  defaultValue = input<any>()

  constructor() {
    effect(() => {
      if(this.formGroup() && this.defaultValue())
        this.formGroup().get(this.controlName())?.setValue(this.defaultValue())
    });
  }

  castToString(value: any): string {
    return value as string;
  }

  get control(): AbstractControl | null {
    return this.formGroup().get(this.controlName());
  }
}
